import { useAsync } from 'react-use';

import { addressToLatLong } from '@service-initiation/shared-data-access-google';
import {
  availableStoresAsyncAtom,
  fullAddressAtom,
  geolocationAtom,
  postalCodeAtom,
  store,
} from '@service-initiation/tech-care-data-access-store';
const GEOGRAPHIC_US_CENTER: { lat: number; lng: number } = {
  lat: 44,
  lng: -103,
};

export const useGeoLatLong = () => {
  return useAsync(async () => {
    const stores = await store.get(availableStoresAsyncAtom(false));
    if (stores.length > 0) return;
    const fullAddress = store.get(fullAddressAtom);
    const postalCode = store.get(postalCodeAtom);
    const geoLocation = store.get(geolocationAtom);

    if (!fullAddress?.address && !postalCode && !geoLocation) {
      return GEOGRAPHIC_US_CENTER;
    }

    const latLong = await addressToLatLong(
      fullAddress?.address ||
        postalCode ||
        `${geoLocation?.latitude}, ${geoLocation?.longitude}`
    );

    return latLong;
  }, []);
};
